/* ============================================================
   Begin Health — Mega Menu behaviour
   - relocates mega panels (rendered in the section group) into the header
   - desktop: hover to open full-width panels
   - mobile: drawer + horizontal drill-in sub-panels
   - announcement bar rotation, search toggle
   ============================================================ */
(function () {
  'use strict';

  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 140;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- relocate panels into the header ---------- */
  function relocatePanels() {
    var deskHost = qs('[data-mm-desktop-panels]');
    var drawer = qs('[data-mm-drawer]');
    if (deskHost) {
      qsa('.mm-panel[data-mm-panel]').forEach(function (panel) {
        if (panel.parentNode !== deskHost) deskHost.appendChild(panel);
      });
    }
    if (drawer) {
      qsa('.mm-mobile-panel[data-mm-mobile-panel]').forEach(function (panel) {
        if (panel.parentNode !== drawer) drawer.appendChild(panel);
      });
    }
  }

  /* ---------- desktop hover panels ---------- */
  var openTimer = null;
  var closeTimer = null;

  function findPanel(sel, handle) {
    var els = qsa(sel);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var primary = el.getAttribute('data-mm-panel') || el.getAttribute('data-mm-mobile-panel');
      if (primary === handle) return el;
      var hs = (el.getAttribute('data-mm-handles') || '').split(/\s+/);
      if (hs.indexOf(handle) !== -1) return el;
    }
    return null;
  }

  function openPanel(handle) {
    clearTimeout(closeTimer);
    var target = findPanel('.mm-panel', handle);
    qsa('.mm-panel.is-open').forEach(function (p) { if (p !== target) p.classList.remove('is-open'); });
    qsa('.mm-nav__item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    var overlay = qs('[data-mm-overlay]');
    if (!target) { closePanels(); return; }
    target.classList.add('is-open');
    var item = qs('.mm-nav__item[data-mm-nav="' + cssEscape(handle) + '"]');
    if (item) item.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
  }

  function closePanels() {
    qsa('.mm-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    qsa('.mm-nav__item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    var overlay = qs('[data-mm-overlay]');
    if (overlay) overlay.classList.remove('is-open');
  }

  function bindDesktop() {
    var header = qs('[data-mm-header]');
    if (!header) return;

    qsa('.mm-nav__item').forEach(function (item) {
      var handle = item.getAttribute('data-mm-nav');
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openPanel(handle); }, OPEN_DELAY);
      });
      // keyboard accessibility
      var link = qs('.mm-nav__link', item);
      if (link) {
        link.addEventListener('focus', function () { openPanel(handle); });
      }
    });

    // close when leaving the whole bar+panels region
    var bar = qs('.mm-bar', header);
    var panels = qs('[data-mm-desktop-panels]');
    [bar, panels].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseleave', function (e) {
        clearTimeout(openTimer);
        closeTimer = setTimeout(closePanels, CLOSE_DELAY);
      });
      el.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    });

    var overlay = qs('[data-mm-overlay]');
    if (overlay) overlay.addEventListener('mouseenter', closePanels);
    if (overlay) overlay.addEventListener('click', closePanels);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanels();
    });
  }

  /* ---------- mobile drawer + drill-in ---------- */
  function bindMobile() {
    var mobile = qs('[data-mm-mobile]');
    if (!mobile) return;
    var toggle = qs('[data-mm-toggle]', mobile);
    var drawer = qs('[data-mm-drawer]', mobile);

    // position the drawer just below the persistent top region
    // (announcement + bar + subbar) so the close button stays visible
    function setDrawerTop() {
      if (!drawer) return;
      var bottom = 0;
      ['.mm-announce', '.mm-mobile__bar', '.mm-subbar'].forEach(function (s) {
        var el = qs(s);
        if (el) {
          var r = el.getBoundingClientRect();
          if (r.height && r.bottom > bottom) bottom = r.bottom;
        }
      });
      if (bottom > 0) drawer.style.top = Math.round(bottom) + 'px';
    }

    function openDrawer() {
      setDrawerTop();
      mobile.classList.add('is-open');
      document.body.classList.add('mm-locked');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      mobile.classList.remove('is-open');
      document.body.classList.remove('mm-locked');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      resetDrill();
    }
    function resetDrill() {
      qsa('.mm-mobile-panel.is-open', mobile).forEach(function (p) { p.classList.remove('is-open'); });
      mobile.classList.remove('mm-drilled');
      var sc = qs('.mm-drawer__scroll', mobile);
      if (sc) sc.scrollTop = 0;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        // when drilled into a sub-panel, the top-left control goes back to main
        if (mobile.classList.contains('mm-drilled')) { resetDrill(); return; }
        if (mobile.classList.contains('is-open')) closeDrawer(); else openDrawer();
      });
    }

    // drill triggers
    qsa('[data-mm-drill]', mobile).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-mm-drill');
        var panel = findPanel('.mm-mobile-panel', handle);
        if (panel) {
          panel.classList.add('is-open');
          mobile.classList.add('mm-drilled');
          var sc = qs('.mm-drawer__scroll', mobile);
          if (sc) sc.scrollTop = 0;
        } else {
          var url = btn.getAttribute('data-mm-fallback-url');
          if (url) window.location.href = url;
        }
      });
    });

    // legacy in-panel back buttons (delegated; panels may be relocated)
    document.addEventListener('click', function (e) {
      var back = e.target.closest && e.target.closest('[data-mm-back]');
      if (!back) return;
      var panel = back.closest('.mm-mobile-panel');
      if (panel) panel.classList.remove('is-open');
      mobile.classList.remove('mm-drilled');
    });

    window.addEventListener('resize', function () {
      if (mobile.classList.contains('is-open')) setDrawerTop();
    });

    // expose for close-on-resize
    mobile._mmClose = closeDrawer;
  }

  /* ---------- announcement bar ---------- */
  function bindAnnounce() {
    var bar = qs('[data-mm-announce]');
    if (!bar) return;
    var slides = qsa('.mm-announce__slide', bar);
    if (slides.length <= 1) return;
    var idx = 0;
    var timer = null;
    var autorotate = bar.getAttribute('data-autorotate') === 'true';
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }
    function restart() { if (autorotate) { clearInterval(timer); timer = setInterval(next, speed); } }

    var nextBtn = qs('[data-mm-announce-next]', bar);
    var prevBtn = qs('[data-mm-announce-prev]', bar);
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    restart();
  }

  /* ---------- search toggle ---------- */
  function bindSearch() {
    var toggle = qs('[data-mm-search-toggle]');
    var drop = qs('[data-mm-search]');
    if (!toggle || !drop) return;
    toggle.addEventListener('click', function () {
      var hidden = drop.hasAttribute('hidden');
      if (hidden) {
        drop.removeAttribute('hidden');
        var input = qs('input[name="q"]', drop);
        if (input) input.focus();
      } else {
        drop.setAttribute('hidden', '');
      }
    });
  }

  /* ---------- helpers ---------- */
  function cssEscape(str) {
    if (window.CSS && CSS.escape) return CSS.escape(str);
    return String(str).replace(/["\\\]\[\.#:>+~*\s]/g, '\\$&');
  }

  var bound = false;
  function init() {
    relocatePanels();
    if (bound) return;
    bound = true;
    bindDesktop();
    bindMobile();
    bindAnnounce();
    bindSearch();

    window.addEventListener('resize', function () {
      var mobile = qs('[data-mm-mobile]');
      if (window.innerWidth >= 1200 && mobile && mobile._mmClose) mobile._mmClose();
      if (window.innerWidth < 1200) closePanels();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* ---------- Shopify theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    relocatePanels();
  });
  document.addEventListener('shopify:section:select', function (e) {
    var sec = e.target;
    if (!sec || !sec.classList || !sec.classList.contains('shopify-section--mega-menu')) return;
    var panel = sec.querySelector('.mm-panel[data-mm-panel]') || qs('.mm-panel[data-mm-panel]');
    if (panel) openPanel(panel.getAttribute('data-mm-panel'));
  });
  document.addEventListener('shopify:section:deselect', function () { closePanels(); });
})();
